import { Link, useLocation } from "react-router-dom";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import { Nav, NavItem } from "./styles";

const items = [
  { label: "Início", path: "/motorista", icon: HomeOutlinedIcon, exact: true },
  { label: "Pontualidade", path: "/motorista/pontualidade", icon: AccessTimeOutlinedIcon },
  { label: "Quebras", path: "/motorista/quebras", icon: ReportProblemOutlinedIcon },
  { label: "Entregas", path: "/motorista/entregas", icon: LocalShippingOutlinedIcon },
  { label: "Caixas", path: "/motorista/caixas", icon: Inventory2OutlinedIcon },
];

export function DriverBottomNav() {
  const { pathname } = useLocation();

  return (
    <Nav>
      {items.map(({ label, path, icon: Icon, exact }) => {
        const isSelected = exact ? pathname === path : pathname.startsWith(path);

        return (
          <NavItem key={path} as={Link} to={path} className={isSelected ? "selected" : ""}>
            <Icon fontSize="small" />
            {label}
          </NavItem>
        );
      })}
    </Nav>
  );
}

export default DriverBottomNav;
